import { FETCH_MENU_MASTER_FAILURE } from '../menuMaster/menuMaster.actionsType';
import {
    CREATE_USER_DETAILS_REQUEST,
    CREATE_USER_DETAILS_SUCCESS,
    CREATE_USER_DETAILS_FAILURE,
    DELETE_USER_DETAILS_REQUEST,
    DELETE_USER_DETAILS_SUCCESS,
    DELETE_USER_DETAILS_FAILURE,
    FETCH_SINGLE_USER_DETAILS_REQUEST,
    FETCH_SINGLE_USER_DETAILS_SUCCESS,
    FETCH_SINGLE_USER_DETAILS_FAILURE,
    FETCH_USER_DETAILS_REQUEST,
    FETCH_USER_DETAILS_SUCCESS,
    FETCH_USER_DETAILS_FAILURE,
    UPDATE_USER_DETAILS_REQUEST,
    UPDATE_USER_DETAILS_SUCCESS,
    UPDATE_USER_DETAILS_FAILURE,
    RESET_USER_DETAILS_INFO,
    CREATE_USER_DETAILS_FORM,
    UPDATE_USER_DETAILS_FORM
} from './userDetails.actionsType';

export const USER_DETAILS = 'userDetails';

let initialState = {
    loading: false,
    userDetails: [],
    userDetailsform: {},
    selectedState: {},
    errorMessage: ''
};

export let userDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_USER_DETAILS_REQUEST:
        case CREATE_USER_DETAILS_REQUEST:
        case UPDATE_USER_DETAILS_REQUEST:
        case FETCH_SINGLE_USER_DETAILS_REQUEST:
        case DELETE_USER_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_USER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userDetails: updatePayload
            };
        case CREATE_USER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userDetailsform: {}
            };
        case UPDATE_USER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userDetailsform: {}
            };
        case FETCH_SINGLE_USER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userDetailsform: updatePayload
            };
        case DELETE_USER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userDetailsform: {}
            };
        case RESET_USER_DETAILS_INFO:
            return {
                ...state,
                userDetailsform: {}
            };
        case CREATE_USER_DETAILS_FORM:
        case UPDATE_USER_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                userDetailsform: {
                    ...state.userDetailsform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_USER_DETAILS_FAILURE:
        case FETCH_MENU_MASTER_FAILURE:
        case CREATE_USER_DETAILS_FAILURE:
        case UPDATE_USER_DETAILS_FAILURE:
        case FETCH_SINGLE_USER_DETAILS_FAILURE:
        case DELETE_USER_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
